//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/Assemblies.js";
import "../no/Session.js";
let d=[[[0,"RestructureConstraints",1,0]],[[[],"NewWaveQuery",{R_:{wavequery:"Assemblies.WaveQuery"}},0,0]],[]];
SPLM.AssembliesUtils = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.AssembliesUtils";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AssembliesUtils.RestructureConstraintsOption = Object.freeze({
    "OnlyComponents" : "OnlyComponents", "IncludeConstraints" : "IncludeConstraints"});

export default SPLM;